import React from 'react';

function CircularLoader() {
  return (
    <div id="loader-wrapper">
      <div id="loader" />
    </div>
  );
}

export default CircularLoader;
